import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import HelmetWrapper from "../../HelmetWrapper";
import { selectUser } from "../../components/auth/auth.selector";
import CommonStructured from "../../components/common-components/CommonStructured";
import CmnFilters from "../../components/lead-management/common/CmnFilters";
import { fetchWTF360ConsultationsData } from "../../redux/prospect-reducers/prospectSlice";
import WTF360ConsultationsListings from "../../components/wtf-360/WTF360ConsultationsListings";
import WTF360ConsultationDetail from "../../components/wtf-360/WTF360ConsultationDetail";
import WTF360ConsultationNotes from "../../components/wtf-360/WTF360ConsultationNotes";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import "../../styles/wtf-360/wtf-360-consultations.css";

const WTF360Consultations = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);
  const { wtf360ConsultationsLoading } = useSelector(
    (state) => state.prospects
  );

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym:
      !isAdmin && !isClusterManager
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    selCity: "",
    isActive: "",
    leadAddDateFrom: "",
    leadAddDateTo: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    preferred_city: allFilters.selCity?.value || "",
    status: allFilters.isActive?.value || "",
    start_date: allFilters.leadAddDateFrom || "",
    end_date: allFilters.leadAddDateTo || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const iniModvalues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  function onCloseModal() {
    setModValues(iniModvalues);
  }

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({
        ...prevs,
        search: allFilters.searchString,
      }));
    }
  };

  function getWTF360Consultations(filters) {
    dispatch(
      fetchWTF360ConsultationsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getWTF360Consultations(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      preferred_city: allFilters.selCity?.value || "",
      status: allFilters.isActive?.value || "",
      start_date: allFilters.leadAddDateFrom || "",
      end_date: allFilters.leadAddDateTo || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selCity,
    allFilters.isActive,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: 360 Consultations">
      <Container
        className="bg-cloud-k px-50px gobal-container"
        fluid
      >
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Detail Modal"
          ariaHideApp={false}
        >
          <div
            className={`createNewCTOModalContainer wtf360ConsultationsModalContainer`}
          >
            <ModalHeadAndClose
              title={
                modValues.modName === "view_details"
                  ? "Consultation Details"
                  : modValues.modName === "notes"
                  ? "Notes"
                  : modValues.modName?.replace(/_/g, " ")
              }
              onClose={onCloseModal}
            />

            {modValues.modName === "view_details" ? (
              <WTF360ConsultationDetail
                userInfoData={userInfoData}
                rowData={modValues.rowData}
                closeModal={onCloseModal}
                callFunction={() => getWTF360Consultations(filters)}
              />
            ) : modValues.modName === "notes" ? (
              <WTF360ConsultationNotes
                rowData={modValues.rowData}
                closeModal={onCloseModal}
              />
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading="WTF 360 Consultations"
              isReload={() => getWTF360Consultations(filters)}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from="wtf-360-consultations"
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              isLoading={wtf360ConsultationsLoading}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <WTF360ConsultationsListings
              isPage={isPage}
              setIsPage={(value) => setIsPage(value)}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default WTF360Consultations;
